import g from "@babel/runtime/helpers/esm/objectSpread2";
import { sstyled as w, assignProps as x } from "@semcore/core";
import e from "react";
import { ScreenReaderOnly as L, Box as m } from "@semcore/flex-box";
import I from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
import _ from "@semcore/icon/Close/m";
import { Hint as M } from "@semcore/tooltip";
var k = {
  trigger: [["onMouseEnter", "onKeyboardFocus", "onTouchStart", "onFocus"], ["onMouseLeave", "onBlur"]],
  popper: [["onMouseEnter", "onFocusCapture", "onTouchStart"], ["onMouseLeave", "onBlur"]]
};
function B(u) {
  var v = arguments[0], r, t = u, p = t.Children, h = t.styles, n = t.value, a = t.displayLabel, l = t.editable, i = t.selected, o = t.onRemove, c = t.getI18nText, b = t.uid, f = M, y = m, C = m, E = "svg", d = "delete_".concat(n, "_").concat(b), S = e.useCallback(function(s) {
    s.key === "Backspace" && (o == null || o(s));
  }, []);
  return r = w(h), /* @__PURE__ */ e.createElement(f, r.cn("SItemContainer", g({}, x({
    interaction: k,
    selected: i,
    value: n,
    displayLabel: a,
    role: "option",
    "aria-selected": i,
    title: n ?? c("clearColor"),
    "aria-describedby": l ? d : void 0,
    onKeyDown: S,
    __excludeProps: ["title"],
    timeout: [250, 50]
  }, v))), !n && /* @__PURE__ */ e.createElement(E, r.cn("SLine", {
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /* @__PURE__ */ e.createElement("rect", r.cn("rect", {
    width: "1",
    height: "22",
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 16.4854 0.928925)",
    fill: "#e0e1e9"
  }))), a && /* @__PURE__ */ e.createElement(y, r.cn("SLabel", {
    "data-value": n || "#6C6E79"
  }), "A"), /* @__PURE__ */ e.createElement(p, r.cn("Children", {})), l && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(C, r.cn("SCloseIcon", {
    tabIndex: -1,
    "aria-hidden": !0,
    onClick: o
  }), /* @__PURE__ */ e.createElement(_, r.cn("CloseM", {
    color: "icon-primary-neutral",
    w: 10,
    h: 10
  }))), /* @__PURE__ */ e.createElement(L, r.cn("ScreenReaderOnly", {
    "aria-hidden": !0,
    id: d
  }), c("deleteColorDescriber"))));
}
B.enhance = [I()];
export {
  B as Item
};
